<template>
    <v-content>
      <v-container fluid fill-height ma-0 pa-0 id="page-container">
        <v-layout>
            <sidebar />
            <v-flex text-xs-center id="page-content">
              <router-view />
            </v-flex>
        </v-layout>
      </v-container>
    </v-content>
</template>

<script>

export default {
  name: 'HomeLayout',
  methods: {
      getBackgroundImage () {
        fetch(`https://source.unsplash.com/collection/9239861/1600x900`).then(
            response => {
            document.getElementById('page-container').style.backgroundImage =
                'url(' + response.url + ')'
            }
        )
      },
      startInterval: function () {
        setInterval(() => {
            this.getBackgroundImage()
        }, 300000)
      }
  },
  mounted () {
    this.getBackgroundImage()
    this.startInterval()
  }
}
</script>

<style lang="scss" scoped>

.v-navigation-drawer {
    background: transparent;
    backdrop-filter: blur(4px) contrast(70%);

    .v-icon, .v-list-item__title {
        color: #fff;
        opacity: .5;
    }
}
</style>
